exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fetch-btn[data-v-6a1d5e11]{background:var(--sub-color);border-radius:21px;width:180px;height:43px;box-sizing:border-box;line-height:43px;font-size:13px;font-weight:700;color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.16078);cursor:pointer}", ""]);
